
export default function About() {
  return (
    <section id="about" className="bg-[#1A1A1A] py-16 md:py-32 px-4 md:px-8 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-16 items-center">
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="relative max-w-md mx-auto lg:max-w-none">
              <div className="bg-white p-2 rounded-3xl shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=leachianus%20gecko%20rhacodactylus%20being%20held%20gently%20on%20human%20hand%20showing%20size%20comparison%20close%20up%20detailed%20view%20of%20gecko%20texture%20and%20patterns%20warm%20lighting%20professional%20reptile%20photography%20simple%20clean%20background&width=600&height=800&seq=about-leach-002&orientation=portrait"
                  alt="Leachianus on hand"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
              <div className="absolute -top-4 -right-4 bg-[#B8E986] text-gray-900 px-3 md:px-6 py-2 md:py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg whitespace-nowrap">
                New Caledonia Native
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 order-1 lg:order-2 text-center lg:text-left">
            <p className="text-[#B8E986] text-xs font-semibold tracking-widest uppercase mb-4 md:mb-6">
              ABOUT THE SPECIES
            </p>
            
            <h2 className="mb-6 md:mb-8">
              <span className="block font-serif italic text-3xl md:text-4xl lg:text-5xl text-white mb-2">The Gentle Giant</span>
              <span className="block font-bold text-3xl md:text-4xl lg:text-5xl text-white">of the Gecko World</span>
            </h2>

            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 leading-relaxed">
              <p>
                The Leachianus gecko, scientifically known as Rhacodactylus leachianus, holds the distinguished title of being the world's largest gecko species. These impressive reptiles can reach lengths of 14-17 inches and weigh between 200-400 grams, making them true giants in the gecko family.
              </p>
              
              <p>
                Despite their imposing size, Leachianus geckos are known for their calm and docile temperament. They are primarily nocturnal creatures, spending their days resting in tree hollows and becoming active at night to hunt for insects and feed on fruit. Their gentle nature and unique personalities make them fascinating companions for experienced reptile enthusiasts.
              </p>
              
              <p>
                Native exclusively to the islands of New Caledonia in the South Pacific, these remarkable geckos inhabit the humid rainforest canopies. While they face habitat loss in the wild, responsible captive breeding programs have helped ensure their continued existence and availability to dedicated keepers worldwide.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-8 md:mt-12 pt-8 md:pt-12 border-t border-gray-700">
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-4xl font-bold text-[#B8E986] mb-2">14-17"</div>
                <div className="text-xs md:text-sm text-gray-400 uppercase tracking-wide">Length</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-4xl font-bold text-[#B8E986] mb-2">200-400g</div>
                <div className="text-xs md:text-sm text-gray-400 uppercase tracking-wide">Weight</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-4xl font-bold text-[#B8E986] mb-2">15-20</div>
                <div className="text-xs md:text-sm text-gray-400 uppercase tracking-wide">Years Lifespan</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-4xl font-bold text-[#B8E986] mb-2">Arboreal</div>
                <div className="text-xs md:text-sm text-gray-400 uppercase tracking-wide">Lifestyle</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
